import { intersection } from 'lodash-es'
// 请求拦截器中转换pageNo和pageSize
export const convertPageNumAndSizeInRequest = function (data, convertPageNumAndSize, paramsType) {
  if (data && convertPageNumAndSize) {
    if (paramsType && paramsType.toLowerCase() === 'json') {
      const { pageNum, pageSize } = data
      if (pageNum && pageSize) {
        data.turnPageBeginPos = (pageNum - 1) * pageSize + 1
        data.turnPageShowNum = pageSize
      }
    } else {
    // 利用连字符&分割
      const dataArr = data.split('&')
      const obj = {}
      // 判断
      dataArr.forEach(item => {
        const target = item.split('=')
        const key = window.decodeURIComponent(target[0])
        const value = window.decodeURIComponent(target[1])
        obj[key] = value
      })
      const { pageNum, pageSize } = obj
      if (pageNum && pageSize) {
        obj.turnPageBeginPos = (pageNum - 1) * pageSize + 1
        obj.turnPageShowNum = pageSize
        // 重新设置config.data
        const arr = []
        Object.keys(obj).forEach(item => {
          const key = window.encodeURIComponent(item)
          const value = window.encodeURIComponent(obj[item])
          arr.push(`${key}=${value}`)
        })
        // 返回新的config.data
        return arr.join('&')
      } else {
        throw new Error('pageNum and pageSize is necessary when use convertPageNumAndSize')
      }
    }
  }
  return data
}

// 定义各种接口响应list的key
const possibleResponseListKeys = [
  // 默认接口列表key
  'data',
  // 查询收款人列表key
  'iCustomerPayeeTemp',
  // 汇款记录列表key
  'iOutwardTransfer',
  // 获取账户信息列表key
  'accountFinalList',
  // 账户信息列表key
  'iAccountInfoList',
  // 账户限额设置列表key
  'iCustAccountIcoll',
  // 交易明细查询
  'accTransDetailsList',
  // 密码重置申请列表
  'iApplyResetListIcoll',
  // 审核指令查询
  'dealOrderList',
  // 治理处理历史
  'iAuthHistory',
  // 用户管理待处理指令
  'iConsoleOrderList'
]
// 响应拦截器中转换表格接口响应体结构
export const convertTableBodyInResponse = function (data, convertPageNumAndSize) {
  if (convertPageNumAndSize) {
    // 保存表格数据
    const reponseDataKeys = Object.keys(data)
    // 这里取响应key和定义key的交集
    const listKey = intersection(reponseDataKeys, possibleResponseListKeys)[0] || ''
    const tableData = data[listKey]
    data.data = {}
    data.data.list = tableData
    data.data.totalSize = Number(data.turnPageTotalNum)
  }
  return data
}
